export function renderLegend(host: HTMLElement) {
  host.innerHTML = `
    <div class="card legend-bar">
      <span class="lbl">Altitude [ft]</span>
      <div class="bar-track">
        <div class="ticks">
          <span style="left:0%">30,000</span>
          <span style="left:33.3%">20,000</span>
          <span style="left:66.7%">10,000</span>
          <span style="left:100%">0</span>
        </div>
      </div>
    </div>
  `;
}
